<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Dedication-rw auto-rw page-open-left-rw" epub:type="frontmatter dedication" id="dedication">
<h1 class="dedication-title"></h1>
<p class="dedication"><a id="page-ix"></a><em>To my Savior King, You taught me how to dance again.</em></p>
<p class="dedication1"><em>To my husband, my knight, I’ll love you until the end of time.</em></p>
<p class="dedication1"><em>To Daniel, Samantha, and Hayley, the three most thoughtful, caring, perfect beings in my world.</em></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?6e984692